import { render, staticRenderFns } from "./features-form.vue?vue&type=template&id=42057f7a&scoped=true"
import script from "./features-form.vue?vue&type=script&lang=js"
export * from "./features-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42057f7a",
  null
  
)

export default component.exports